const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  error: (...args) => {
    console.error(...args);
  },
};

export default logger;
